module.exports = __webpack_public_path__ + "img/slogan-en.7e04872c.svg";